import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getReviews } from "../../redux/actions";
import { useState, useEffect } from "react";
import Paginado from "../ConsolaUsuarios/Paginado";
const Reviews = () => {
  const dispatch = useDispatch();
  const reviews = useSelector((state) => state.reviews)
  const pagesReviews = useSelector((state) => state.pagesReviews)
  const [page, setPage] = useState(1);
  useEffect(() => {
    getListReview();
 
  }, [page]);
  const getListReview = async () => {
    await dispatch(getReviews(page));
    return;
  };

  const handlePageChange =async (newPage) => {
   setPage(newPage); 
    
  };
  return (
    <div className="container">
        <h5 className="mb-3">Opiniones de usuarios</h5>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Fecha</th>
            <th scope="col">Usuario</th>
            <th scope="col">Cuil</th>
            <th scope="col">Descripción</th>
            <th scope="col">Puntuación</th>
          </tr>
        </thead>
        {reviews?.map((review,i) => {
          return (
            <tbody key={i}>
              <tr >
                <td>{review.dateOpinion}</td>
                <td>
                  {review.nombre} {review.apellido}
                </td>
                <td>{review.cuit}</td>
                <td>{review.opinion}</td>
                <td>{review.starts}</td>
              </tr>
            </tbody>
          );
        })}
      </table>
      <Paginado data={pagesReviews} pagina={page} setPagina={handlePageChange} />
    </div>
  );
};

export default Reviews;
